module.exports = __webpack_public_path__ + "img/karriere-weiterbildung-v1.67fd753c.jpg";